import { render, staticRenderFns } from "./ListPriceDetail.vue?vue&type=template&id=4bbdd79e"
import script from "./ListPriceDetail.vue?vue&type=script&lang=js"
export * from "./ListPriceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports